// ======================================================================
// File Name       : ServiceRecordList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Row, Table, Form } from 'react-bootstrap';
import TableHead from '../../../components/TableHead';
import { DEFAULT_DATE_FORMAT, RETURN_MAX_NUM } from '../../../constants/index';
import { parseDateForDetail } from '../../../utils/index';
import { convertByte, convertToHour, getServiceUsageListForServiceList } from '../../../utils/ServiceRecordUtils';
import CustomButton from '../../button/CustomButton';
import ServiceRecordMaxInfo from './ServiceRecordMaxInfo';
import ReduxFormPaging from '../../ReduxFormPaging';

class ServiceRecordList extends React.Component {
  constructor(props) {
    super(props);
    this.tableBody = [];
    this.maxInfo = {};
    this.drawTable = this.drawTable.bind(this);
  }

  drawTable(list) {
    const { isSupperUserL0, isUsingNewPlan } = this.props;
    let maxNumId = 0;
    let maxLMSStorage = 0;
    let maxVideoStorage = 0;
    let maxVideoFlowRate = 0;
    let maxMultiLanguageDocumentPage = 0;
    const tableBody = {
      body: null,
      maxInfo: null,
    };
    if (list && list.length) {
      tableBody.body = list.map((item, index) => {
        const {
          recordDate,
          serviceCd,
          idTotalNum,
          documentS3Usage,
          clientContentsS3Usage,
          drillS3Usage,
          drillDbUsage,
          otherS3Usage,
          videoStorageUsage,
          ownVideoFlow,
          distributionVideoFlow,
          createdAt,
          downloadFormOK,
          liveFlow,
          liveUsageTime,
          multiLanguageDocumentPage,
        } = item;
        if (idTotalNum > maxNumId) {
          maxNumId = idTotalNum;
        }
        if (videoStorageUsage > maxVideoStorage) {
          maxVideoStorage = videoStorageUsage;
        }

        const tempLMSStorage = documentS3Usage + drillS3Usage + drillDbUsage + otherS3Usage + clientContentsS3Usage;

        if (tempLMSStorage > maxLMSStorage) {
          maxLMSStorage = tempLMSStorage;
        }
        let videoFlowRate = 0;
        if (!isNaN(parseInt(distributionVideoFlow, 10))) {
          videoFlowRate += distributionVideoFlow;
        }
        if (!isNaN(parseInt(ownVideoFlow, 10))) {
          videoFlowRate += ownVideoFlow;
        }
        maxVideoFlowRate += videoFlowRate;

        if (!isNaN(parseInt(multiLanguageDocumentPage, 10)) &&
          multiLanguageDocumentPage > maxMultiLanguageDocumentPage
        ) {
          maxMultiLanguageDocumentPage = multiLanguageDocumentPage;
        }

        return (
          <tr key={index}>
            <td>
              {parseDateForDetail(recordDate, DEFAULT_DATE_FORMAT)}
            </td>
            <td>
              {idTotalNum}
            </td>
            <td>
              {convertByte(tempLMSStorage)}
            </td>
            <td>
              {convertByte(videoStorageUsage)}
            </td>
            <td>
              {convertByte(videoFlowRate)}
            </td>
            <td>
              {(multiLanguageDocumentPage && multiLanguageDocumentPage.toLocaleString()) || 0}
            </td>
          </tr>
        );
      });
      tableBody.maxInfo = {
        numberId: maxNumId,
        LMSStorage: convertByte(maxLMSStorage),
        videoStorageUsage: convertByte(maxVideoStorage),
        videoFlowRate: convertByte(maxVideoFlowRate),
        multiLanguageDocumentPage: `${maxMultiLanguageDocumentPage.toLocaleString()} ページ`,
      };
    }
    return tableBody;
  }

  // Step 12.3.0 TAS-21359 START
  drawServiceList(serviceList, serviceUsageList) {
    const tableBody = {
      body: null,
    };
    if (serviceList && serviceList.length) {
      tableBody.body = serviceList.map((service, index) => {
        const {
          serviceCd,
          serviceName,
        } = service;
        let maxNumId = 0;
        let maxTotalStorage = 0;
        let maxTotalVideoFlow = 0;
        let maxVideoStorage = 0;
        let maxMultiLanguageDocumentPage = 0;

        if (serviceUsageList && serviceUsageList[serviceCd]) {
          const data = serviceUsageList[serviceCd];
          maxNumId = data.maxNumId;
          maxTotalStorage = data.maxTotalStorage;
          maxTotalVideoFlow = data.maxTotalVideoFlow;
          maxVideoStorage = data.maxVideoStorage;
          maxMultiLanguageDocumentPage = data.maxMultiLanguageDocumentPage;
        }

        return (
          <tr key={index}>
            <td>
              {serviceName}
            </td>
            <td>
              {maxNumId || 0}
            </td>
            <td>
              {convertByte(maxTotalStorage) || 0}
            </td>
            <td>
              {convertByte(maxVideoStorage) || 0}
            </td>
            <td>
              {convertByte(maxTotalVideoFlow) || 0}
            </td>
            <td>
              {maxMultiLanguageDocumentPage || 0}
            </td>
          </tr>
        );
      });
    }
    return tableBody;
  }
  // Step 12.3.0 TAS-21359 END

  render() {
    const {
      onChangeSortKind,
      downloadFormOK,
      serviceCd,
      isCompany,
      isSupperUserL0,
      isUsingNewPlan,
      isServiceList,
      serviceInfo,
      recordNum,
      getStartEndData,
      startPosition,
    } = this.props;
    const { serviceList } = serviceInfo;

    let thead = null;
    if (isSupperUserL0) {
      thead = [
        { title: isServiceList ? 'サービス名' : '月日', sortBy: null },
        { title: 'ID数', sortBy: null },
        { title: 'LMSストレージ', sortBy: null },
        { title: 'ビデオストレージ', sortBy: null },
        { title: 'ビデオ流量', sortBy: null },
        { title: '多言語ドキュメントページ数', sortBy: null},
      ];
    } else {
      thead = [
        { title: isServiceList ? 'サービス名' : '月日', sortBy: null },
        { title: 'ID数', sortBy: null },
        { title: 'LMSストレージ', sortBy: null },
        { title: 'ビデオストレージ', sortBy: null },
        { title: 'ビデオ流量', sortBy: null },
        { title: '多言語ドキュメントページ数', sortBy: null },
      ];
    }

    const tableBody = isServiceList
      ? this.drawServiceList(serviceList, getServiceUsageListForServiceList(this.props.serviceUsageList))
      : this.drawTable(this.props.serviceUsageList);

    tableBody.maxInfo = {
      ...tableBody.maxInfo,
      isSupperUserL0,
      isUsingNewPlan,
    };

    return (
      <div>
        {!isServiceList && (
          <ServiceRecordMaxInfo
            {...tableBody.maxInfo}
          />
        )}
        <Col sm={12} className="padding-left-right-clear margin-top-20 margin-bottom-20">
          <Col sm={3} className="padding-left-clear margin-top-20">
            {isServiceList ? 'サービスごとの最大利用量' : '日ごとの利用量'}
          </Col>
          <Col className="text-right padding-right-clear" sm={9}>
            <CustomButton
              btnStyle="btn btn-export-csv float-end"
              handleClick={downloadFormOK}
              text="一括出力"
              iconClass="bi bi-download"
              isDisabled={!isCompany && !serviceCd}
            />
          </Col>
        </Col>
        <Table striped hover>
          <thead>
            <TableHead data={thead} handleSortState={onChangeSortKind} />
          </thead>
          <tbody>{tableBody.body}</tbody>
        </Table>
        {isServiceList && recordNum> 0 && (
          <Row className="text-center">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Row>
        )}
      </div>
    );
  }
}

export default ServiceRecordList;
